export default "__VITE_ASSET__AyzjaJ4R__"